<div class="header">
  <div>
    <a  routerLink="/all" class="header__back" aria-label="Voltar para a tela anterior" data.test="linkBackProfile" >Voltar</a>
    <h2 class="header__title" data.test="nameProfile">{{ personName }}</h2>
    <up-ui-copy-button [newBrand]="isColaboratorModule" id="copyNameProfile" [label]="personName | accents | uppercase"></up-ui-copy-button>
  </div>
  <div class="header-actions">
    <div class="header__status" [ngClass]="{'--active': action}">
      <div class="switch-container">
        <p class="toogle-guia" data.test="labelStatusProfile">{{active ? "Ativo" : "Inativo"}}</p>
        <div class="switch" >
            <input id="guia" class="cmn-toggle cmn-toggle-round" data.test="btnChangeStatusProfile" type="checkbox" (change)="openDialogChangeStatus($event)" [checked]="this.active">
            <label for="guia"></label>
        </div>
      </div>
    </div>
  </div>
</div>
